import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { ShopProvider } from "./store/ShopContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { MiniCart } from "./components/MiniCart";
import { SearchOverlay } from "./components/SearchOverlay";
import { CompareBar } from "./components/CompareBar";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import Product from "./pages/Product";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import Wishlist from "./pages/Wishlist";
import Compare from "./pages/Compare";
import Account from "./pages/Account";
import { InfoPage, ContactPage } from "./pages/Info";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    try {
      window.scrollTo({ top: 0 });
    } catch {
      /* ignore */
    }
  }, [pathname]);
  return null;
};

const Shell = () => (
  <>
    <Header />
    <main className="min-h-[60vh]">
      <Outlet />
    </main>
    <Footer />
  </>
);

const NotFound = () => (
  <div data-testid="not-found-page" className="container-cc py-32 text-center">
    <p className="eyebrow mb-3">404</p>
    <p className="font-serif text-4xl">Pagina nu există</p>
  </div>
);

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <ShopProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<Shell />}>
              <Route path="/" element={<Home />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/catalog/:category" element={<Catalog />} />
              <Route path="/produs/:slug" element={<Product />} />
              <Route path="/cos" element={<Cart />} />
              <Route path="/favorite" element={<Wishlist />} />
              <Route path="/comparare" element={<Compare />} />
              <Route path="/cont" element={<Account />} />
              <Route path="/comanda/:number" element={<OrderSuccess />} />
              <Route path="/despre" element={<InfoPage slug="despre" />} />
              <Route path="/termeni" element={<InfoPage slug="termeni" />} />
              <Route path="/confidentialitate" element={<InfoPage slug="confidentialitate" />} />
              <Route path="/cookies" element={<InfoPage slug="cookies" />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/checkout" element={<Checkout />} />
          </Routes>
          <MiniCart />
          <SearchOverlay />
          <CompareBar />
          <Toaster position="top-center" toastOptions={{ className: "rounded-none border border-black/10 font-sans", style: { fontFamily: "Manrope, sans-serif" } }} />
        </BrowserRouter>
      </ShopProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
